import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { MessageCircle, Phone } from 'lucide-react'
import { ButtonLink, buttonClasses } from '@/components/generals/button-link'
import { Eyebrow } from '@/components/generals/section-heading'
import { contactInfo } from '@/constants/site'
import { MEDIA } from '@/constants/media'

interface CtaBandProps {
    title?: string
    description?: string
}

export const CtaBand: FC<CtaBandProps> = ({
    title = "برای خرید عمده و صادرات، با ما در تماس باشید",
    description = "محصول، مقدار و کشور مقصد را بنویسید تا مشخصات فنی، پیش‌فاکتور و شرایط ارسال نمونه را برایتان بفرستیم."
}): ReactNode => {
    const primaryPhone = contactInfo.phones[0]

    return (
        <section id='contact-cta' aria-labelledby='contact-cta-title' className='relative isolate overflow-hidden bg-forest-950 text-cream'>
            <Image
                src={MEDIA.zagrosValley}
                alt=''
                fill
                sizes='100vw'
                className='-z-10 object-cover object-[50%_65%] opacity-40'
            />

            <div aria-hidden='true' className='absolute inset-0 -z-10 bg-linear-to-l from-forest-950 via-forest-950/85 to-forest-950/30' />

            <div className='mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28'>
                <div className='max-w-2xl'>
                    <Eyebrow tone='dark'>
                        همکاری تجاری
                    </Eyebrow>

                    <h2 id='contact-cta-title' className='mt-4 text-4xl font-bold sm:text-5xl'>
                        {title}
                    </h2>

                    <p className='mt-5 text-base leading-8 text-cream/75 sm:text-lg sm:leading-9'>
                        {description}
                    </p>

                    <div className='mt-9 flex flex-wrap gap-3'>
                        <ButtonLink href='/contact' variant='gold' size='lg'>
                            ارسال استعلام قیمت
                        </ButtonLink>

                        <a
                            href={contactInfo.whatsapp.url}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={buttonClasses('outline-light', 'lg')}
                        >
                            <MessageCircle aria-hidden='true' />
                            واتس‌اپ
                        </a>

                        <a href={`tel:${primaryPhone.tel}`} className={buttonClasses('outline-light', 'lg')}>
                            <Phone aria-hidden='true' />
                            <span dir='ltr'>{primaryPhone.display}</span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}
